import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Button } from '../../components/atoms/Buttons'
import AdminProfile from '../../components/AdminProfile/AdminProfile'
import SaddlefitLogo from '../../assets/icons/logo.svg?react'
import { Stepper } from '../../components/Stepper'
import { useUserContext } from '../../context/UserContext'

function StripeConnect() {
  const [authLoading, setAuthLoading] = useState(false)
  const navigate = useNavigate()
  const currentStep = 2
  const { isOpen, setIsOpen, stepperSteps } = useUserContext()

  const handleStripeConnect = async () => {
    try {
      setAuthLoading(true)

      const { tokens } = await fetchAuthSession()
      const idToken = tokens.idToken?.toString()

      const resp = await fetch(import.meta.env.VITE_STRIPE_VALIDATE_URL, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })

      const { stripeConnectUrl } = await resp.json()
      console.log('stripeConnectUrl', stripeConnectUrl)

      setAuthLoading(false)
      window.location.href = stripeConnectUrl
    } catch (error) {
      console.error('Error connecting to Stripe:', error)
      setAuthLoading(false)
    }
  }

  const handleStepChange = async stepIndex => {
    console.log({ stepIndex })
    if (stepIndex === 0) {
      navigate('/onboarding')
    } else if (stepIndex === 1) {
      navigate('/shopify-connect')
    } else if (stepIndex === 2) {
      navigate('/stripe-connect')
    }
  }

  return (
    <div className="w-full h-screen flex">
      <div className="admin-dashboard-card-section mx-auto w-[100%]">
        <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>

        <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <Stepper
            steps={stepperSteps}
            currentStep={currentStep}
            onStepChange={handleStepChange}
            allowClickNavigation={true}
            showNavigation={false}
            className="mb-8"
          />
        </div>

        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] h-[100%] mx-auto">
          <div className="w-full flex flex-col items-center mb-5 sm:mb-0 h-auto mt-10">
            <div className="flex flex-col sm:flex-row items-center justify-between max-w-[745px] w-full">
              <SaddlefitLogo />
              <span
                className="text-[#2B364B] font-montserrat font-semibold hover:underline !w-auto cursor-pointer inline-flex items-center justify-center"
                role="button"
                disabled={authLoading}
                onClick={() => navigate('/admin-dashboard')}
              >
                Skip
              </span>
            </div>
            <h1 className="admin-dashboard text-center">
              Connect your Stripe Account
            </h1>

            <div className="mt-6">
              <Button
                onClick={handleStripeConnect}
                className="create-saddle-btn !w-[150px] cursor-pointer"
                loading={authLoading}
              >
                Connect Stripe
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StripeConnect
